import { MyPurchaseForm } from "src/app/shared/models/app-models";

export const doesNotMeetRfsCriteria = (form: MyPurchaseForm) => {
    return ( (form.PurchaseTypeId !== 1 && form.PurchaseTypeId !== 3)  || 
    !form.documentNo || !form.documentStatusId || !form.isRFS || 
    form.documentSubStatusId == 2 
    || form.documentStatusId == 15 || form.documentStatusId == 2)
}